import { BookingState } from '../../modules/booking-state/BookingState';
import { SendConfirmationMessagePageContext } from './SendConfirmationMessagePageContext';
import { withPageContext } from '../../modules/contexts/WithPageContext';
import { useViewProvider } from '../../modules/contexts/view-provider-context/ViewProvider';
import { SendConfirmationMessagePageViewProps } from './SendConfirmationMessagePageViewProps';
import { useBookingContext } from '../../modules/booking-state/UseBookingContext';
import { useEffect } from 'react';

function ContextAccessor({
  selectedDealer,
  selectedSlot,
  createdBooking,
  noDealer
}: BookingState): SendConfirmationMessagePageContext | null {
  // Only what the page shows is required: everything else is dropped from the state on arrival.
  if (!(selectedSlot && selectedDealer && createdBooking)) {
    return null;
  }

  return {
    createdBooking,
    selectedDealer,
    selectedSlot,
    noDealer: !!noDealer,
  };
}

export const SendConfirmationMessagePage = withPageContext(ContextAccessor, ({ pageContext }) => {
  const viewProvider = useViewProvider();
  const [bookingState, setBookingContext] = useBookingContext();

  // The booking is made, so the customer's identity, contact details and vehicle have no further
  // use and are not kept: only what this page displays stays. It also means that going Back to
  // the review step finds no booking to submit a second time.
  useEffect(() => {
    setBookingContext({
      createdBooking: bookingState.createdBooking,
      selectedDealer: bookingState.selectedDealer,
      selectedSlot: bookingState.selectedSlot,
      foundDealersCount: bookingState.foundDealersCount,
    });
  }, []);

  const viewProps: SendConfirmationMessagePageViewProps = {
    createdBooking: pageContext.createdBooking,
    selectedDealer: pageContext.selectedDealer,
    selectedServiceDate: pageContext.selectedSlot.date,
    // A dealer without a DMS gets the request as a lead, and the backend then returns no booking
    // id — the same test it uses to pick the wording of the confirmation e-mail. The page used
    // to ask for the dealer's DMS mapping instead: until that answered it showed "Thank you for
    // booking" with an empty booking number, and when it failed the customer got an error
    // dialog on top of a request that had gone through.
    noDealer: !pageContext.createdBooking.bookingId,
  };

  return viewProvider.renderSendConfirmationMessagePage(viewProps);
});
